<template>
  <v-autocomplete

      v-model="model"
      :items="items"
      :search-input.sync="search"
      item-text="name"
      item-value="_id"

      :label="label"
      :placeholder="placeholder"
      :ariaRequired=ariaRequired
      :prependIcon="prependIcon"
      :color="color"
      :flat="flat"
      :solo="solo"
      :clearable="clearable"
      :multiple="multiple"

      :loading="isLoading"

      :chips="multiple"
      return-object
  />
</template>

<script>
import axios from "axios";

export default {
  name: "Suggest",
  data() {
    return {
      model: null,
      isLoading: false,
      search: null,
      entries: [],
    };
  },
  mounted() {

    if(this.modelSelected) {
      this.model = this.modelSelected;

      if(this.modelSelected instanceof Array) {
        this.entries = this.modelSelected;
      }else{
        this.entries = [this.modelSelected];
      }
    }

  },
  computed: {
    items() {
      return this.entries.map(entry => {
        return Object.assign({}, entry);
      });
    },
  },
  watch: {
    model(model) {
      this.select(model);
    },
    search(val) {

      // Items have already been requested
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      let component = this;
      let baseUri = `${process.env.VUE_APP_SERVICE_URI_COURSE}/api`;

      const queryParams = {
        page: 1,
        limit: 10,
        name: `/${val}/i`,
      };

      switch (this.searchType) {
        case 'categories':
          baseUri += `/categories`;
          break;
        case 'awardingBody':
          baseUri += `/certification-bodies`;
          break;
        case 'level':
          baseUri += `/levels`;
          break;
      }

      axios.get(baseUri, {
        params: queryParams,
      }).then(function (response) {
        // handle success
        component.entries = response.data.docs;
      }).catch(function () {
        // TODO handle error later
      }).finally(function () {
        // always executed
        component.isLoading = false;
      });

    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    ariaRequired: {
      type: Boolean,
      required: true,
    },
    prependIcon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    flat: {
      type: Boolean,
      required: true,
    },
    solo: {
      type: Boolean,
      required: true,
    },
    clearable: {
      type: Boolean,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: true,
    },
    searchType: {
      type: String,
      validator: function (value) {
        // The value must match one of these strings
        return ['categories', 'level', 'awardingBody'].indexOf(value) !== -1;
      },
    },
    select: {
      type: Function,
      required: true,
    },
    modelSelected: {
      required: true,
    },
  },
};
</script>